import common from './common.json';
import guests from './guests.json';

export default {
  common,
  guests,
};
